import { DEFAULT_CLASSIFICATION } from '@/shared/lib/constants';
import type { TreeSelectNode } from '@/shared/ui/EditableTreeSelect';

import type { TagOption } from '@/entities/tags';

/**
 * 태그 옵션 배열을 classification 기준으로 트리 구조로 변환
 */
export const convertTagsToTree = (tags: TagOption[]): TreeSelectNode[] => {
  const classificationMap = new Map<string, TagOption[]>();

  tags.forEach((tag) => {
    const classification = tag.classification || DEFAULT_CLASSIFICATION;
    if (!classificationMap.has(classification)) {
      classificationMap.set(classification, []);
    }
    classificationMap.get(classification)!.push(tag);
  });

  const treeData: TreeSelectNode[] = [];

  classificationMap.forEach((tagList, classification) => {
    const sortedTags = tagList.sort((a, b) => a.label.localeCompare(b.label));

    const children: TreeSelectNode[] = sortedTags.map((tag) => ({
      value: tag.value,
      title: tag.label,
      key: tag.value,
      isLeaf: true,
      classification: tag.classification,
      description: tag.description,
      classificationFQN: tag.classificationFQN,
    }));

    const isMutuallyExclusive = tagList[0]?.mutuallyExclusive || false;
    const classificationFQN = tagList[0]?.classificationFQN;

    treeData.push({
      value: `classification-${classification}`,
      title: classification,
      key: `classification-${classification}`,
      selectable: false,
      disabled: true,
      mutuallyExclusive: isMutuallyExclusive,
      classificationFQN: classificationFQN,
      children,
    });
  });

  return treeData.sort((a, b) => {
    const aTitle = typeof a.title === 'string' ? a.title : '';
    const bTitle = typeof b.title === 'string' ? b.title : '';
    return aTitle.localeCompare(bTitle);
  });
};
